import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useInView } from '../../hooks/useInView';
import './AboutCollectionsRow.css';

const FEATURED_COLLECTIONS = [
  'Champagne Glass',
  'Drinkware',
  'For Him',
  'For Her',
];

const AboutCollectionsRow: React.FC = () => {
  const navigate = useNavigate();
  const { ref: aboutRef, isInView: aboutInView } = useInView<HTMLElement>({ threshold: 0.2 });
  const heritageStats = ['40+ Years', 'Irish Craft', 'Bespoke Awards'];
  const tileBackgrounds: Record<string, string> = {
    'For Her': "url('/Untitled design (28).png')",
    'Champagne Glass': "url('/Untitled design (29).png')",
    'Drinkware': "url('/Untitled design (27).png')",
    'For Him': "url('/Untitled design (25).png')",
  };

  const handleCategoryClick = (category: string) => {
    navigate(`/shop?category=${encodeURIComponent(category)}`);
  };

  return (
    <section ref={aboutRef} className={`about-collections-row ${aboutInView ? 'about-visible' : ''}`}>
      <div className="about-collections-container">
        <div className="our-story-shell">
          <div className="our-story-text-panel">
            <span className="our-story-heritage-mark" aria-hidden="true">40</span>
            <p className="about-card-eyebrow">Our Story</p>
            <h2 className="about-card-title">About Quirke Trophies</h2>
            <p className="about-card-intro">
              Quirke Trophies, founded by John Quirke, Jeweller, Cahir has, for over 50 years, been an
              integral part of community life in South Tipperary.
            </p>
            <p className="about-card-text">
              We have been proud to share in the successes of our customers and to help celebrate their
              achievements in sport, education, community activism and the Arts.
            </p>
            <p className="about-card-text">
              Our shop is based at Glengall House, the Square, Cahir. We provide bespoke trophies, cups
              and memorabilia for all occasions.
            </p>
            <div className="about-stat-row">
              {heritageStats.map((stat) => (
                <span key={stat} className="about-stat-item">
                  {stat}
                </span>
              ))}
            </div>
            <button
              className="about-card-link"
              onClick={() => navigate('/about')}
            >
              Read More
            </button>
          </div>

          <div className="our-story-image-panel">
            <img
              src="/a47da927-1856-428b-b8e4-3a65848b74d6.png"
              alt="Artisan engraving a gold globe trophy with Quirke Trophies nameplate"
              className="our-story-image"
            />
          </div>
        </div>

        <div className="collections-editorial">
          <div className="collections-header">
            <p className="collections-eyebrow">Curated Categories</p>
            <h3 className="collections-card-title">Featured Collections</h3>
          </div>
          <div className="collections-mosaic">
            {FEATURED_COLLECTIONS.map((collection, index) => (
              <button
                key={collection}
                className={`collection-tile ${index === 0 ? 'collection-tile-large' : ''}`}
                onClick={() => handleCategoryClick(collection)}
                style={{ ['--tile-bg' as any]: tileBackgrounds[collection] }}
                data-collection-index={index}
              >
                <span className="collection-tile-label">Collection</span>
                <span className="collection-tile-name">{collection}</span>
                <span className="collection-tile-arrow" aria-hidden="true">↗</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCollectionsRow;
